import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { PayrollReport } from "../../../components/Reports/PayrollReport";

export interface IPayrollReportSetupPage {}

export const PayrollReportSetupPage: FC<IPayrollReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Payroll Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PayrollReport />}
		/>
	);
};
